import { Typography } from '@mui/material';
import { useMemo } from 'react';
import { formatDateShort } from '@/utils/helpers';

const updatedAtStyles = {
  text: {
    fontSize: '0.625rem',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
};

type UpdatedAtProps = {
  date: string | null | undefined;
  prefix?: string;
};

const UpdatedAt = ({ date, prefix = 'Updated' }: UpdatedAtProps) => {
  const formattedDate = useMemo(() => {
    return date ? formatDateShort(date) : '—';
  }, [date]);

  const textContent = useMemo(() => {
    return `${prefix}: ${formattedDate}`;
  }, [prefix, formattedDate]);

  return (
    <Typography
      variant='caption'
      color='text.secondary'
      sx={updatedAtStyles.text}
      data-id='updated-at'
    >
      {textContent}
    </Typography>
  );
};

export { UpdatedAt };
export type { UpdatedAtProps };
